<template>
  <span
    class="inline-block mx-1 py-2px px-2 rounded-sm bg-gray-200 font-mono text-xs text-gray-900"
    >{{ text }}</span
  >
</template>

<script>
export default {
  name: 'Shortcut',
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>
